import { GenericDropdown } from '@/forms-legacy'
import { useOptions } from './useOptions'

type RecurrenceEndCalendarDropdownProps = {
  date: uui.domain.YYYYMMDD
  onFocus?: () => void
}

const onChange = () => undefined

export function RecurrenceEndCalendarDropdown(props: RecurrenceEndCalendarDropdownProps) {
  const { date, onFocus } = props

  const options = useOptions(date)

  return (
    <GenericDropdown
      name="recurrenceEndDate"
      selectedIds={[date]}
      values={options}
      onChanged={onChange}
      onFocus={onFocus}
      editable={false}
    />
  )
}
